import styled from 'styled-components';
import Select from 'react-select';

const SelectWrapper = styled(Select)`
  > .css-yk16xz-control,
  .css-1pahdxg-control {
    border: solid 1px #e9edf4;
    background-color: #fafdff;
    height: 45px;
    box-shadow: none;
    &:hover,
    &:active,
    &:focus {
      border: solid 1px #e9edf4;
    }
  }
  .css-1wa3eu0-placeholder {
    color: #adb6c6;
  }
`;

export { SelectWrapper };
